import {create} from 'zustand';

type VelaTripState = {
  destination: string;
  dateRange: string;
  dayCount: number;
  totalStops: number;
  sources: string[];
  assumptions: string[];
} | null;

type VelaTripStore = {
  trip: VelaTripState;
  setTrip: (trip: VelaTripState) => void;
};

export const useVelaTripStore = create<VelaTripStore>(set => ({
  trip: null,
  setTrip: trip => set({trip}),
}));
